export default __webpack_public_path__ + "static/A-TrustedExpertise-3aaf06f400395dff36db0dbe05ae9483.png";